import { findProductsPriceByClient } from '../../_services/product_price.service';
import { createOrder } from '../../_services/order.service';

import { 
    buildselectClientBody,
    buildAddItemBody,
    cleanQuantityImput,
    cleanOrderInputs,
    validateAddItemt,
    buildGenerateOrderBody, 
    validateGenerateOrder 
} from './generate_order.inputs';

export const selectClientForOrderEvent = async (clients) => {
    let body = buildselectClientBody();
    let partsclient = body.client.replaceAll(" ","").split("-");
    let index = clients.findIndex(d => d.identification === partsclient[1]);
    if(index === -1) throw new Error('Cliente no encontrado');
    let clientId = index === -1 ? '' : clients[index].uuid;    
    let res = await findProductsPriceByClient(clientId);
    return {
        products: res.list,
        client: clients[index]
    };
}

export const addItemOrderEvent = async (price) => {
    let body = buildAddItemBody(price);
    validateAddItemt(body);
    cleanQuantityImput();
    return body;
}

export const generateOrderEvent = async (items) => {
    let body = buildGenerateOrderBody(items);
    validateGenerateOrder(body);
    let res = await createOrder(body);
    if(! res.ok) throw new Error(res.error);
    cleanOrderInputs();
    return res;
}